var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{attrs:{"title":"Settings","show":true,"confirmClose":false},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"form--wrapper general"},[_c('label',[_vm._v("No settings available for this element, please contact us for any help with setting up this channel.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }